module.exports = __webpack_public_path__ + "img/slider.b923da23.svg";